import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { lyLessons } from '../../mocks/ly-lessons';

const LyPage = () => {
  const categories = ['Cơ học', 'Điện học', 'Quang học', 'Nhiệt học'];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <main className="pt-24">
        {/* Hero Section */}
        <section className="py-20 px-6 bg-gradient-to-br from-amber-50 via-orange-50 to-yellow-50 relative overflow-hidden">
          <div className="absolute inset-0 opacity-10">
            <img 
              src="https://public.readdy.ai/ai/img_res/eee5a4e692df456e0f7dacf5bae12637.jpg"
              alt="Vật lý background"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="max-w-7xl mx-auto text-center relative z-10">
            <div className="inline-flex items-center gap-2 bg-orange-100 text-orange-700 px-4 py-2 rounded-full text-sm font-medium mb-6">
              <i className="ri-flashlight-fill"></i>
              <span>Vật Lý</span>
            </div>
            <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Merriweather, serif' }}>
              Vật Lý Lớp 6-12
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Khám phá thế giới vật lý với các định luật, công thức và thí nghiệm thực tế. 
              Học từ cơ học, điện học đến quang học một cách dễ hiểu và sinh động
            </p>
            <div className="mt-10 flex flex-wrap justify-center gap-4">
              <a href="#bai-hoc" className="px-8 py-3 bg-orange-600 text-white rounded-lg font-medium hover:bg-orange-700 transition-colors whitespace-nowrap cursor-pointer">
                Xem bài học
              </a>
              <a href="#dinh-luat" className="px-8 py-3 bg-white text-orange-600 rounded-lg font-medium border-2 border-orange-600 hover:bg-orange-50 transition-colors whitespace-nowrap cursor-pointer">
                Định luật
              </a>
            </div>
          </div>
        </section>

        {/* Stats Section */}
        <section className="py-12 px-6 bg-white border-b">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
              <div className="text-center">
                <div className="text-4xl font-bold text-orange-600 mb-2">{lyLessons.length}+</div>
                <div className="text-gray-600">Bài học</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-orange-600 mb-2">500+</div>
                <div className="text-gray-600">Định luật</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-orange-600 mb-2">300+</div>
                <div className="text-gray-600">Thí nghiệm</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-orange-600 mb-2">1500+</div>
                <div className="text-gray-600">Bài tập</div>
              </div>
            </div>
          </div>
        </section>

        {/* Categories Section */}
        <section id="danh-muc" className="py-16 px-6 bg-gradient-to-b from-gray-50 to-white">
          <div className="max-w-7xl mx-auto">
            <h2 className="text-3xl font-bold text-center text-gray-900 mb-12" style={{ fontFamily: 'Merriweather, serif' }}>
              Danh Mục Vật Lý
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {categories.map((category, index) => {
                const icons = ['ri-speed-line', 'ri-flashlight-line', 'ri-eye-line', 'ri-temp-hot-line'];
                const lessonCount = lyLessons.filter(l => l.category === category).length;
                return (
                  <a 
                    key={index}
                    href={`#${category.toLowerCase().replace(/\s+/g, '-')}`}
                    className="group bg-white p-8 rounded-xl border-2 border-gray-200 hover:border-orange-500 hover:shadow-lg transition-all cursor-pointer"
                  >
                    <div className="w-14 h-14 bg-gradient-to-br from-orange-500 to-amber-600 rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                      <i className={`${icons[index]} text-white text-2xl`}></i>
                    </div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2">{category}</h3>
                    <p className="text-sm text-gray-600">
                      {lessonCount > 0 ? `${lessonCount} bài học` : 'Đang cập nhật'}
                    </p>
                  </a>
                );
              })}
            </div>
          </div>
        </section>

        {/* Lessons Section */}
        <section id="bai-hoc" className="py-16 px-6 bg-white">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Merriweather, serif' }}>
                Bài Học Vật Lý
              </h2>
              <p className="text-gray-600 max-w-2xl mx-auto">
                Định luật vật lý, công thức chi tiết và bài tập ứng dụng thực tế từ cơ bản đến nâng cao
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {lyLessons.map((lesson) => (
                <article key={lesson.id} className="bg-white rounded-xl border border-gray-200 hover:shadow-xl transition-all overflow-hidden group">
                  <div className="h-48 bg-gradient-to-br from-orange-100 to-amber-100 relative overflow-hidden">
                    <img 
                      src={`https://readdy.ai/api/search-image?query=modern%20physics%20equipment%20laboratory%20tools%20circuits%20electricity%20on%20warm%20amber%20orange%20background%20clean%20educational%20design%20creating%20scientific%20atmosphere&width=600&height=400&seq=ly-${lesson.id}&orientation=landscape`}
                      alt={lesson.title}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500 object-top"
                    />
                    <div className="absolute top-4 right-4 bg-orange-600 text-white px-3 py-1 rounded-full text-xs font-medium">
                      Lớp {lesson.grade}
                    </div>
                  </div>
                  <div className="p-6">
                    <div className="flex items-center gap-2 text-xs text-gray-500 mb-3">
                      <span className="bg-orange-100 text-orange-700 px-2 py-1 rounded">{lesson.category}</span>
                      <span>•</span>
                      <span><i className="ri-time-line"></i> {lesson.readTime} phút</span>
                      <span>•</span>
                      <span><i className="ri-eye-line"></i> {lesson.views.toLocaleString()}</span>
                    </div>
                    <h3 className="text-lg font-bold text-gray-900 mb-3 line-clamp-2 group-hover:text-orange-600 transition-colors">
                      {lesson.title}
                    </h3>
                    <p className="text-sm text-gray-600 mb-4 line-clamp-2">
                      {lesson.excerpt}
                    </p>
                    <a 
                      href={`/ly/${lesson.slug}`}
                      className="inline-flex items-center gap-2 text-orange-600 font-medium text-sm hover:gap-3 transition-all cursor-pointer"
                    >
                      Xem chi tiết
                      <i className="ri-arrow-right-line"></i>
                    </a>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 px-6 bg-gradient-to-br from-orange-600 to-amber-600 text-white">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-4xl font-bold mb-6" style={{ fontFamily: 'Merriweather, serif' }}>
              Khám Phá Vật Lý Ngay Hôm Nay
            </h2>
            <p className="text-xl mb-8 text-orange-50">
              Hiểu sâu các định luật vật lý và áp dụng vào thực tế cuộc sống
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <a href="#bai-hoc" className="px-8 py-4 bg-white text-orange-600 rounded-lg font-medium hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer">
                Khám phá ngay
              </a>
              <a href="/lien-he" className="px-8 py-4 bg-orange-700 text-white rounded-lg font-medium hover:bg-orange-800 transition-colors border-2 border-white/30 whitespace-nowrap cursor-pointer">
                Liên hệ tư vấn
              </a>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default LyPage;
